import React from 'react';
import { CheckCircle, Clock, XCircle, AlertTriangle } from 'lucide-react';
import { FinancialSummary } from '../../types/ltss';

interface ClaimsStatusProps {
  financials: FinancialSummary;
}

export function ClaimsStatus({ financials }: ClaimsStatusProps) {
  const total = financials.claimsPaid + financials.claimsPending + 
                financials.claimsNotSubmitted + financials.claimsVoided;

  const statuses = [
    {
      label: 'Paid',
      count: financials.claimsPaid,
      percentage: total > 0 ? Math.round((financials.claimsPaid / total) * 100) : 0,
      icon: CheckCircle,
      color: 'text-green-400',
      bgColor: 'bg-green-500',
    },
    {
      label: 'Pending',
      count: financials.claimsPending,
      percentage: total > 0 ? Math.round((financials.claimsPending / total) * 100) : 0,
      icon: Clock,
      color: 'text-yellow-400',
      bgColor: 'bg-yellow-500',
    },
    {
      label: 'Not Submitted',
      count: financials.claimsNotSubmitted,
      percentage: total > 0 ? Math.round((financials.claimsNotSubmitted / total) * 100) : 0,
      icon: AlertTriangle,
      color: 'text-orange-400',
      bgColor: 'bg-orange-500',
    },
    {
      label: 'Voided',
      count: financials.claimsVoided,
      percentage: total > 0 ? Math.round((financials.claimsVoided / total) * 100) : 0,
      icon: XCircle,
      color: 'text-red-400',
      bgColor: 'bg-red-500',
    },
  ];

  return (
    <div className="card p-4">
      <h3 className="text-sm font-medium text-slate-400 mb-4">Claims Status</h3>
      
      {/* Stacked bar */}
      <div className="h-4 bg-slate-700 rounded-full overflow-hidden flex mb-4">
        {statuses.map((status) => (
          status.percentage > 0 && (
            <div
              key={status.label}
              className={`${status.bgColor} transition-all duration-300`}
              style={{ width: `${status.percentage}%` }}
              title={`${status.label}: ${status.count} (${status.percentage}%)`}
            />
          )
        ))}
      </div>

      {/* Legend */}
      <div className="grid grid-cols-2 gap-3">
        {statuses.map((status) => (
          <div key={status.label} className="flex items-center gap-2">
            <status.icon className={`w-4 h-4 ${status.color}`} />
            <span className="text-sm text-slate-300">{status.label}</span>
            <span className={`text-sm font-medium ${status.color} ml-auto`}>
              {status.count}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
